export default __webpack_public_path__ + "static/img-conference-2019-ac1823a4caab6ed163313d656ebe3995.png";